import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "circle-exclamation-orange",
  "use": "circle-exclamation-orange-usage",
  "viewBox": "0 0 78 78",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 78 78\" id=\"circle-exclamation-orange\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M39 78c21.54 0 39-17.46 39-39S60.54 0 39 0 0 17.46 0 39s17.46 39 39 39zm0-14.625a4.875 4.875 0 100-9.75 4.875 4.875 0 000 9.75zM34.125 19.5a4.875 4.875 0 119.75 0V39a4.875 4.875 0 11-9.75 0V19.5z\" fill=\"#F18053\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol